import { ButtonLink } from '../components/Button';
import { Reveal } from '../components/Reveal';
import { Accent, SectionHeading } from '../components/SectionHeading';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/**
 * Reachable by URL but deliberately not linked from the nav, matching the commented-out link
 * in the old _Layout.cshtml. Link it once there is something here.
 */
export default function Services() {
  useDocumentTitle('Services');

  return (
    <div className="bg-gradient-to-b from-mint-100 to-cream">
      <div className="mx-auto max-w-2xl px-6 py-20 text-center sm:px-8 sm:py-28">
        <Reveal>
          <SectionHeading eyebrow="Services">
            Services I can <Accent>offer</Accent>.
          </SectionHeading>
        </Reveal>

        <Reveal delay={90}>
          <div className="mt-10 rounded-blob bg-white px-8 py-14 shadow-soft">
            <span aria-hidden="true" className="text-5xl">
              🌱
            </span>
            <p className="mt-6 leading-relaxed">
              This page is still growing. Please come back soon to see everything I can offer — or
              just ask me directly, and I&apos;ll walk you through it.
            </p>
            <div className="mt-10">
              <ButtonLink to="/contact" variant="blush">
                💬 Ask me about it
              </ButtonLink>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
